import { Phone, ArrowRight, CheckCircle } from 'lucide-react';
import { useChatContext } from '../context/ChatContext';
import Button from '../components/Button';

function Hero() {
  const { openChat } = useChatContext();

  return (
    <section className="relative min-h-[94svh] flex items-end overflow-hidden text-white bg-night">
      <div className="absolute inset-0 -top-[30svh] -bottom-[30svh] overflow-hidden">
        <img
          src="/assets/img/hero-1280.webp"
          srcSet="/assets/img/hero-mobile.webp 800w, /assets/img/hero-1280.webp 1280w"
          sizes="100vw"
          alt="Betonpumpe von MH-BETON auf einer Baustelle"
          width="1280"
          height="721"
          fetchPriority="high"
          className="w-full h-full object-cover scale-[1.08] saturate-[0.92] contrast-[1.05]"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(90deg, rgba(5,12,15,0.88), rgba(7,25,31,0.58) 48%, rgba(7,25,31,0.22)), linear-gradient(0deg, rgba(7,25,31,0.72), rgba(7,25,31,0.12) 48%)',
          }}
        />
      </div>
      <div
        className="absolute inset-x-0 bottom-0 h-[32%] pointer-events-none"
        style={{ background: 'linear-gradient(0deg, rgba(243,248,251,0.92), rgba(243,248,251,0))' }}
      />

      <div className="container-site mx-auto relative z-10 grid lg:grid-cols-[0.95fr_minmax(300px,360px)] gap-8 lg:gap-[clamp(2rem,5vw,5.5rem)] items-end pb-[4.4rem] sm:pb-[5.4rem] lg:pb-[6.4rem] pt-[7.4rem] sm:pt-[8.4rem] lg:pt-[9.4rem]">
        <div className="max-w-[860px]">
          <p className="text-sm font-black uppercase tracking-wider text-signal mb-3 animate-[hero-rise_720ms_cubic-bezier(0.16,1,0.3,1)_forwards_520ms] opacity-0 translate-y-[18px]">
            Betonpumpe mit Fahrer · Transport · Verkauf
          </p>
          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-[5.05rem] font-black leading-[1.05] mb-4 animate-[hero-rise_720ms_cubic-bezier(0.16,1,0.3,1)_forwards_640ms] opacity-0 translate-y-[18px]">
            Beton kommt an. <span className="block font-bold text-white/80">Genau dort, wo er hin soll.</span>
          </h1>
          <p className="text-base sm:text-lg md:text-xl leading-relaxed text-white/85 max-w-[680px] mb-7 animate-[hero-rise_720ms_cubic-bezier(0.16,1,0.3,1)_forwards_760ms] opacity-0 translate-y-[18px]">
            MH-BETON koordiniert Betonpumpe, Transport und Verkauf für Wien, Wien Umgebung und Niederösterreich.
            Vor Ort zählt Timing, Zufahrt, Pumpweg und eine klare Abstimmung.
          </p>
          <div className="flex flex-wrap gap-3 mb-6 animate-[hero-rise_720ms_cubic-bezier(0.16,1,0.3,1)_forwards_880ms] opacity-0 translate-y-[18px]">
            <Button href="tel:+436609091992" variant="primary">
              <Phone className="w-[18px] h-[18px]" />
              Jetzt anrufen
            </Button>
            <Button href="#assistent" onClick={openChat} variant="secondary">
              Projekt anfragen
              <ArrowRight className="w-[18px] h-[18px]" />
            </Button>
          </div>
          <div className="flex flex-wrap gap-2 animate-[hero-rise_720ms_cubic-bezier(0.16,1,0.3,1)_forwards_1000ms] opacity-0 translate-y-[18px]">
            {['Direkte Abstimmung', 'Fahrer inklusive', 'Wien & NÖ'].map((tag) => (
              <span
                key={tag}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-white/20 bg-[rgba(7,34,44,0.62)] backdrop-blur-md text-sm font-bold text-white/95"
              >
                <CheckCircle className="w-3.5 h-3.5 text-signal" />
                {tag}
              </span>
            ))}
          </div>
        </div>

        <aside aria-label="Projekt-Check" className="p-4 rounded-card border border-white/15 bg-[rgba(7,34,44,0.66)] backdrop-blur-md shadow-[0_24px_70px_rgba(0,0,0,0.24)] animate-[hero-rise_720ms_cubic-bezier(0.16,1,0.3,1)_forwards_1040ms] opacity-0 translate-y-[18px]">
          <p className="text-sm font-black uppercase tracking-wider text-signal mb-2">Projekt-Check</p>
          <strong className="block text-lg font-bold mb-3">Damit der Einsatz sitzt.</strong>
          <ul className="grid gap-2 mb-4">
            {[
              ['01', 'Baustellenort und Zufahrt klären'],
              ['02', 'Betonmenge und Terminfenster abstimmen'],
              ['03', 'Pumpe, Fahrer und Transport einteilen'],
            ].map(([num, text]) => (
              <li key={num} className="flex items-start gap-2 p-2.5 rounded-md border border-white/10 bg-white/5 text-sm text-white/80">
                <span className="text-xs font-extrabold text-signal">{num}</span>
                {text}
              </li>
            ))}
          </ul>
          <Button onClick={openChat} variant="dark" className="w-full">
            Assistent starten
          </Button>
        </aside>
      </div>
    </section>
  );
}

export default Hero;
